

const products = [
  {
    title: "DẠ YÊN THẢO",
    image: require("../../../assets/ImageSliderDetail/IMG_4344.JPG"),
    descriptions: [
      "Cây khỏe, sai hoa, màu sắc đa dạng",
      "Dòng hạt F1 cho năng suất cao",
      "Có nhiều sự lựa chọn cho từng mục đích khác nhau"
    ]
  },
  {
    title: "Cây con",
    image: require("../../../assets/ImageSliderDetail/IMG_3391.JPG"),
    descriptions: [
      "Được gieo từ hạt F1",
      "Sử dụng 100% giá thể Klasmann",
      "Đạt chuẩn cây con đầu ra sau 30-90 ngày cho từng chủng loại"
    ]
  },

  {
    title: "Đồng tiền",
    image: require("../../../assets/ImageSliderDetail/IMG_3402.JPG"),
    descriptions: [
      "Có nhiều sự lựa chọn về màu sắc",
      "Tỷ lệ nảy mầm cao, cây con phát triển khỏe",
      "Đường kính hoa và tán cây lớn, ra hoa liên tục, bền hoa"
    ]
  },
  {
    title: "Giá thể Klasmann",
    image: require("../../../assets/ImageSliderDetail/IMG_4337.JPG"),
    descriptions: [
      "Thành phần chính là rong thủy đài",
      "Cấu trúc rỗng, xốp giúp cân bằng lượng không khí & nước, giúp bộ rễ phát triển khỏe mạnh",
      "Có nhiều sự lựa chọn cho từng yêu cầu cụ thể"
    ]
  },
  {
    title: "Dụng cụ cây trồng",
    image: require("../../../assets/ImageSliderDetail/IMG_4341.JPG"),
    descriptions: [
      "Đa dạng chủng loại: bình tưới, bay xúc, khay gieo hạt, kéo cắt cành,…",
      "Thiết kế tiện lợi, dễ sử dụng cho mọi đối tượng",
      "Độ bền cao, phù hợp với điều kiện làm vườn trong nước"
    ]
  }
];

export default products;
